import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";
import { GeneralProviderTrainingRequest, AttestationAcknowledgementRequest, AttestationType } from 'containers/Pages/User/QualityOverview/Modals';

export interface DownloadableForm {
  "RmiUid": number,
  "RmiCompanyId": string,
  "RmiFormName": string,
  "RmiFileLink": string,
  "RmiStartTime": string,
  "RmiEndTime": string,
  "RmiSortOrder": number,
  "RmiCreatedBy": null,
  "RmiCreatedDate": string,
  "RmiModifiedBy": null,
  "RmiModifiedDate": string
};
export interface FaxOptOutProvider {
  exists: boolean;
  companyId: string;
  provKeyId: string;
}

export interface FaxOptStatus {
  FaxOptOutProviders: FaxOptOutProvider[];
  VendorNames: string[];
  CompanyNames: CompanyName[];
}

export interface CompanyName {
  companyId: string;
  companyName: string;
}

export const createStatistic = (authNo: string, companyId: string, status: any, refType: any, userId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.CREATE_STATISTIC_REQUEST });

  let statistic = {
    RmiCompanyId: companyId,
    RmiUserId: userId,
    RmiRefType: refType,
    RmiReferenceNo: authNo,
    RmiRefStatus: status
  };

  return api.app.createStatistic(statistic)
    .then((res: any) => {

      dispatch({
        type: types.CREATE_STATISTIC_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CREATE_STATISTIC_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getIpaByUser = (userId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_IPA_BY_USER_REQUEST });

  return api.app.getIpaByUser(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_IPA_BY_USER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_IPA_BY_USER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getVendors = (provKeyId: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_VENDORS_REQUEST });

  return api.app.getVendors(provKeyId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_VENDORS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_VENDORS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getDistinctVendors = (provKeyId: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_VENDORS_REQUEST });

  return api.app.getDistinctVendors(provKeyId, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_VENDORS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_VENDORS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const reportIssue = (form: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.REPORT_ISSUE_REQUEST });

  return api.app.reportIssue(form)
    .then((res: any) => {

      dispatch({
        type: types.REPORT_ISSUE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.REPORT_ISSUE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getContacts = () => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_CONTACTS_REQUEST });

  return api.app.getContacts()
    .then((res: any) => {

      dispatch({
        type: types.GET_CONTACTS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CONTACTS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getCompaniesInfo = () => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_COMPANIES_INFO_REQUEST });

  return api.app.getCompaniesInfo()
    .then((res: any) => {

      dispatch({
        type: types.GET_COMPANIES_INFO_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_COMPANIES_INFO_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getDownloadableForms = () => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_DOWNLOADABLE_FORMS_REQUEST });

  return api.app.getDownloadableForms()
    .then((res: DownloadableForm[]) => {

      dispatch({
        type: types.GET_DOWNLOADABLE_FORMS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_DOWNLOADABLE_FORMS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getDownloadableResources = (materialType: string, measureCode: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_DOWNLOADABLE_RESOURCES_REQUEST });

  return api.app.getDownloadableResources(materialType, measureCode, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_DOWNLOADABLE_RESOURCES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_DOWNLOADABLE_RESOURCES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getDownload = (filename: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_DOWNLOAD_FILE_REQUEST });

  return api.app.getDownload(filename)
    .then((res: any) => {

      dispatch({
        type: types.GET_DOWNLOAD_FILE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_DOWNLOAD_FILE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getDownloadResources = (filename: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_DOWNLOAD_RESOURCES_REQUEST });
  const fileNameArr = filename.split("\\");
  const lastElement = fileNameArr[fileNameArr.length - 1];
  const cleanFilename = lastElement.replace(/[^a-zA-Z0-9.]+/g, '');

  return api.app.getDownloadResources(cleanFilename.toLowerCase(), companyId.toLowerCase())
    .then((res: any) => {

      dispatch({
        type: types.GET_DOWNLOAD_RESOURCES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_DOWNLOAD_RESOURCES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};


export const getUserAcknowledgement = (userId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_USER_ACK_REQUEST });

  return api.app.getUserAcknowledgement(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_USER_ACK_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_USER_ACK_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getFaxOptOutExists = (userId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_FAX_OUT_REQUEST });

  return api.app.getFaxOptOutExists(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_FAX_OUT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_FAX_OUT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const generateFaxOptReport = (userId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.CREATE_FAX_OUT_REPORT_REQUEST });

  return api.app.generateFaxOptReport(userId)
    .then((res: any) => {

      dispatch({
        type: types.CREATE_FAX_OUT_REPORT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CREATE_FAX_OUT_REPORT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const bulkInsertFaxOptOutProviders = (parameter: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.app.isCreatingUserAck) { return Promise.reject(); }

  dispatch({ type: types.CREATE_FAX_OUT_REQUEST });

  return api.app.bulkInsertFaxOptOutProviders(parameter)
    .then((res: any) => {

      dispatch({
        type: types.CREATE_FAX_OUT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CREATE_FAX_OUT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const createUserAcknowledgement = (userModel: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.app.isCreatingUserAck) { return Promise.reject(); }

  dispatch({ type: types.CREATE_USER_ACK_REQUEST });

  return api.app.createUserAcknowledgement(userModel)
    .then((res: any) => {

      dispatch({
        type: types.CREATE_USER_ACK_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CREATE_USER_ACK_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const sendFeedback = (formObject: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.app.isAddingFeedback) { return Promise.reject(); }

  dispatch({ type: types.SEND_USER_FEEDBACK_REQUEST });

  return api.app.sendFeedback(formObject)
    .then((res: any) => {

      dispatch({
        type: types.SEND_USER_FEEDBACK_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SEND_USER_FEEDBACK_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getMeasureReportPrintFile = (params: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_MEASURE_REPORT_PRINT_FILE_REQUEST });

  return api.app.getMeasureReportPrintFile(params)
    .then((res: any) => {

      dispatch({
        type: types.GET_MEASURE_REPORT_PRINT_FILE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_MEASURE_REPORT_PRINT_FILE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const updateShowWebPilotPosting = (payload: any) => (dispatch: ThunkDispatch<any, any, any>) => {
  dispatch({
    type: types.UPDATE_SHOW_WEB_PILOT_POSTING,
    payload
  });

  return Promise.resolve(payload);
};


export const updateFaxOptOutProviders = (payload: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({
    type: types.UPDATE_FAX_OPT_OUT_PROVIDERS,
    payload
  });

  return Promise.resolve(payload);
};

export const updateCompanyNames = (payload: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({
    type: types.UPDATE_COMPANY_NAMES,
    payload
  });

  return Promise.resolve(payload);
};

export const updateVendorNames = (payload: any) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({
    type: types.UPDATE_VENDOR_NAMES,
    payload
  });

  return Promise.resolve(payload);
};

export const GetAttestationPopupContent = (attestationName: string) => (dispatch: ThunkDispatch<any, any, any>) => {
  dispatch({ type: types.GET_ATTESTATION_POPUP_CONTENT_REQUEST });

  return api.app.GetAttestationPopupContent(attestationName)
    .then((res: AttestationType) => {
      dispatch({
        type: types.GET_ATTESTATION_POPUP_CONTENT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_ATTESTATION_POPUP_CONTENT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const CheckAttestationVisibility = (userId: string, attestationName: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.CHECK_ATTESTATION_VISIBILITY_REQUEST });

  return api.app.CheckAttestationVisibility(userId, attestationName)
    .then((res: any) => {

      dispatch({
        type: types.CHECK_ATTESTATION_VISIBILITY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CHECK_ATTESTATION_VISIBILITY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const AddAttestationAcknowledgement = (userModel: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.app.isCreatingUserAck) { return Promise.reject(); }

  dispatch({ type: types.ADD_ATTESTATION_REQUEST });

  return api.app.AddAttestationAcknowledgement(userModel)
    .then((res: any) => {

      dispatch({
        type: types.ADD_ATTESTATION_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.ADD_ATTESTATION_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const DownloadAttestation = (requestModel: AttestationAcknowledgementRequest) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.app.isRequestingPDF) { return Promise.reject(); }

  dispatch({ type: types.DOWNLOAD_ATTESTATION_REQUEST });

  return api.app.DownloadAttestation(requestModel)
    .then((res: any) => {

      dispatch({
        type: types.DOWNLOAD_ATTESTATION_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.DOWNLOAD_ATTESTATION_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const GetAllAttestationTimestamp = (userId: string) => (dispatch: ThunkDispatch<any, any, any>) => {

  dispatch({ type: types.GET_ALL_ATTESTED_TIMESTAMP_REQUEST });

  return api.app.GetAllAttestationTimestamp(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_ALL_ATTESTED_TIMESTAMP_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_ALL_ATTESTED_TIMESTAMP_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

